import { registerLocaleData } from '@angular/common';
import localeDutch from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFinnish from '@angular/common/locales/fi';
import localeNorwegian from '@angular/common/locales/nb';
import localeNatherland from '@angular/common/locales/nl';
import { Injectable } from '@angular/core';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { ThemesService } from 'projects/Autofacets-Core/src/app/services/themes.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { CurrentLanguage } from '../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { CultureCodes } from '../../../../Autofacets-Core/src/app/utils/enums';
import { SettingService } from '../business-services/setting.service';
import { BehaviorSubject } from 'rxjs';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { environment } from 'projects/Administration/src/environments/environment';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class CultureLocaleService {

  constructor(
    private settingService: SettingService,
    private secureStorage: SecureStorage,
    private currentLanguage: CurrentLanguage,
    private themservice: ThemesService,
    private globalSetting: GlobalSetting,
    private msalService: MsalService,
  ) { }

  private _locale: string;
  private cultureCode: string;
  private timeZone: string;
  public currencyCode: string;
  public currency: string;
  globalizationValues: any;
  public globalSettingValues: BehaviorSubject<any> = new BehaviorSubject<any>([]);;

  async initialise() {
    this.cultureCode = Constant.defaultISOCultureCode;
    this.timeZone = Constant.defaultTimeZone;
    EnvSetting.BRAND_API_URL = `${environment.ADMIN_API_URL}Setting/GetBrandLogo`;
    EnvSetting.ItemStatusIconUrl = `${environment.ADMIN_API_URL}Setting/GetItemStatusIcon`;
    EnvSetting.VIEW_IMAGE_API_URL = `${environment.ADMIN_API_URL}Document/ViewImage`;
    const userLoggedIn = (this.msalService.instance.getAllAccounts().length > 0);
    if (userLoggedIn) {
      await this.settingService.GetSettings().then((res) => {
        if (res?.responseObject) {
          this.globalSetting.MapAppSetting(res.responseObject);
          this.globalizationValues = res.responseObject;
          this.globalSettingValues.next(res.responseObject);
          if (this.globalizationValues && this.globalizationValues.length > 0) {
            let LicencePlateClass = this.globalizationValues.filter(x => x.property === 'LicencePlateClass');
            this.secureStorage.setKeyData('LicencePlateClass', LicencePlateClass[0].value);
            let VATPercentage = this.globalizationValues.filter(x => x.property === 'Tax');
            this.secureStorage.setKeyData('VATPercentage', VATPercentage[0].value);
            this.secureStorage.setKeyData('LicencePlateClass', LicencePlateClass[0].value);
            let Version = this.globalizationValues.filter(x => x.property === 'Version');
            this.secureStorage.setKeyData('Version', Version[0].value);
            this.currentLanguage.versionSubject.next(Version[0].value);
            let tenant = this.globalizationValues.filter(x => x.property === 'Tenant');
            localStorage.setItem('Theme', tenant[0].value);
            let cultureCodeValue = this.globalizationValues.filter(x => x.property === 'CultureCode');
            if (cultureCodeValue) {
              this.cultureCode = cultureCodeValue[0].value;
              this.currentLanguage.cultureCodeSubject.next(cultureCodeValue[0].value);
              this.secureStorage.setKeyData('CultureCode', cultureCodeValue[0].value);
            }
            let timeZoneValue = this.globalizationValues.filter(x => x.property === 'TimeZoneStandardName');
            if (timeZoneValue) {
              this.timeZone = timeZoneValue[0].value;
              this.currentLanguage.timeZoneStandradName.next(this.timeZone);
              this.secureStorage.setKeyData('TimeZoneStandradName', this.timeZone);
            }
            let VAT = this.globalizationValues.filter(x => x.property === 'Tax');
            if (VAT) {
              this.currentLanguage.vatSubject.next(VAT[0].value)
            }
            this.secureStorage.setKeyData('Tax', VAT[0].value);
            if (tenant && tenant[0].value) {
              this.themservice.themeInitializer();
            }
            this.currencyCode = this.settingService.getCurrencyCode(this.cultureCode);
            this.currency = this.settingService.getCurrencySymbol(this.currencyCode);
            let logo = this.globalizationValues.filter(x => x.property === 'LogoUrlLink');
            this.secureStorage.setKeyData('LogoUrlLink', logo[0].value);
            let WidgetLogoUrlLink = this.globalizationValues.filter(x => x.property === 'WidgetLogoUrlLink');
            this.secureStorage.setKeyData('WidgetLogoUrlLink', WidgetLogoUrlLink[0].value);
            let LaborUnitPrice = this.globalizationValues.filter(x => x.property === 'LaborUnitPrice');
            this.secureStorage.setKeyData('LaborUnitPrice', LaborUnitPrice[0].value);
            let LaborDurationInMinute = this.globalizationValues.filter(x => x.property === 'LaborDurationInMinute');
            this.secureStorage.setKeyData('LaborDurationInMinute', LaborDurationInMinute[0].value);
            let applyDiscountOnFixedPriceReverse = this.globalizationValues.filter(x => x.property === 'ApplyDiscountOnFixedPriceReverse');
            if (applyDiscountOnFixedPriceReverse != null && applyDiscountOnFixedPriceReverse.length > 0) {
              this.secureStorage.setKeyData('ApplyDiscountOnFixedPriceReverse', applyDiscountOnFixedPriceReverse[0].value);
            } else {
              this.secureStorage.setKeyData('ApplyDiscountOnFixedPriceReverse', "0");
            }
            if (EnvSetting.language.LanguageOverRule) {
              this.currentLanguage.currentLanguage.next(EnvSetting.language.LanguageOverRuleDefault);
            }
            else {
              this.currentLanguage.currentLanguage.next(EnvSetting.LANGUAGE_CONFIG.defaultLanguage);
            }
          }
          this.settingService.getCountry();
          this.getLocale();
          this.setUserLocale();
        }
      });
    }
  }

  getLocaleEN() {
    this._locale = 'en'
    registerLocaleData(localeEn, 'en');
  }

  getLocale(): string {
    this.registerCulture(EnvSetting.CultureFormat || CultureCodes.EN_US)
    return this._locale;
  }

  registerCulture(culture: string) {
    switch (culture) {
      case CultureCodes.NB_NO: {
        this._locale = 'no'
        registerLocaleData(localeNorwegian, 'no');
        break;
      }
      case CultureCodes.EN_US: {
        this._locale = 'en'
        registerLocaleData(localeEn, 'en');
        break;
      }
      case CultureCodes.FI_FI: {
        this._locale = 'fi'
        registerLocaleData(localeFinnish, 'fi');
        break;
      }
      case CultureCodes.NL_NL: {
        this._locale = 'nl'
        registerLocaleData(localeNatherland, 'nl');
        break;
      }
      case CultureCodes.DE_DE: {
        this._locale = 'de'
        registerLocaleData(localeDutch, 'de');
        break;
      }
      default:
        this.getLocaleEN();
    }
  }

  isQtyPrice(event, value) {
    let rgx = /[0-9]+[.,]?[0-9]*$/;
    const str = value + event.key;
    return str.match(rgx)
  }

  setUserLocale() {
    const currentLocale = localStorage.getItem('userLocale');
    if (currentLocale !== this._locale) {
      localStorage.setItem('userLocale', this._locale);
      location.reload(); 
    } 
  }
}